import Action from "../base/action";
import LoadTimeline from "../base/load-timeline";

class CommandAction extends Action {
    properties;
    until;
    commandAction;
    styleId;
    _command;
    _timeout;

    DefaultStyle = {
        backgroundColor: {r: 24, g: 103, b: 192},
        backgroundHoverColor: {r: 8, g: 87, b: 160},
        opacity: 1,
        textColor: {r: 255, g: 255, b: 255, a: 1}
    };

    constructor(props) {
        super(props);
        this.properties = props;
        this.until = props.until || props.duration;
        this.commandAction = new LoadTimeline(props.commandAction);
        this.styleId = props.styleId || null;
        this._timeout = null;
    }

    _initStyle(style = {}) {
        this.properties = {...this.DefaultStyle, ...style.properties, ...this.properties};
    }

    async execute(eventLoop) {
        const self = this;
        if (this.styleId) {
            self._initStyle(eventLoop.training.resources[this.styleId]);
        }
        self._command = {
            text: self.properties.text,
            backgroundColor: self.properties.backgroundColor,
            backgroundHoverColor: self.properties.backgroundHoverColor,
            textColor: self.properties.textColor,
            opacity: self.properties.opacity,
            callback: async () => await this.commandAction.execute(eventLoop)
        };

        CommandPromptManager.addNewCommand(self._command, self.properties);
        updateInputMenuConfig(50, self.properties);

        self._timeout = setTimeout(() => this.stop(), this.until - this.startTime);
    }

    async stop() {
        if (this._timeout) {
            clearTimeout(this._timeout);
            this._timeout = null;
        }
        CommandPromptManager.removeCommand(this._command, this.properties);
    }
}

export default CommandAction;
